import { Address, Currency, Money } from '@rygen/rygen-ui/model';

import { Contact } from '../Contact';

import { CargoInsuranceProviderCommodity } from './CargoInsuranceProviderCommodity';
import { CargoInsuranceProviderEquipmentType } from './CargoInsuranceProviderEquipmentType';

export class CargoInsuranceQuoteRequest {
  coverageLimit: Money;
  equipmentType?: CargoInsuranceProviderEquipmentType;
  commodities: CargoInsuranceProviderCommodity[] = [];
  insured: Contact;

  constructor(opts?: Partial<CargoInsuranceQuoteRequest>) {
    if (opts?.coverageLimit != null) {
      this.coverageLimit = new Money(opts.coverageLimit);
    } else {
      this.coverageLimit = Money.zero(Currency.USD);
    }

    if (opts?.equipmentType != null) {
      this.equipmentType = { ...opts.equipmentType };
    }

    if (opts?.commodities != null) {
      this.commodities = opts.commodities.map((x) => ({ ...x }));
    }

    this.insured = new Contact({
      address: new Address({ country: 'USA' }),
      ...opts?.insured,
    });
  }
}
